import {commitMutation, graphql} from 'react-relay';
import environment from '../data/environment';

const mutation = graphql`
  mutation DeleteWidgetMutation(
    $input: DeleteWidgetInput!
  ) {
    deleteWidget(input: $input) {
      id
      reportId
    }
  }
`;

function commit({widgetId}) {
  commitMutation(
    environment,
    {
      mutation,
      variables: {
        input: {
          id: widgetId,
        },
      },
      updater: (store) => {
        const payload = store.getRootField('deleteWidget');
        const widgetId = payload.getDataID();
        const reportId = payload.getValue('reportId');
        const report = store.get(reportId);
        const widgets = report.getLinkedRecords('widgets');
        const newWidgets = widgets.filter(widget => widget.getDataID() !== widgetId);
        report.setLinkedRecords(newWidgets, 'widgets');
      },
    },
  );
}

export default {commit};



// WEBPACK FOOTER //
// ./src/mutations/DeleteWidgetMutation.js